import type { DownloadedDocumentContent } from "web_myplann/Api/Document/downloadDocumentContent";
import { openInBrowserTab } from "web_myplann/Utils/device";

const REVOKE_DELAY_MS = 100;

export const openDocumentInBrowser = ({ blob }: DownloadedDocumentContent) => {
	const blobUrl = URL.createObjectURL(blob);
	openInBrowserTab(blobUrl);
	setTimeout(() => URL.revokeObjectURL(blobUrl), REVOKE_DELAY_MS);
};
